// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see AutoReloadEntryPointViewedEvent
 *
 * @deprecated Use MoneyBrowseViewItem or BankingOptionBrowseViewItem instead.
 */
export var AutoReloadEntryPointViewed = function (_a) {
    var location = _a.location;
    return ({
        name: "AutoReload EntryPoint Viewed",
        parameters: {
            cdf_entity: "AutoReload",
            cdf_action: "EntryPoint",
            location: location !== undefined && location !== null ? location.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see AutoReloadSettingsViewedEvent
 */
export var AutoReloadSettingsViewed = function () { return ({
    name: "AutoReload Settings Viewed",
    parameters: {
        cdf_entity: "AutoReload",
        cdf_action: "Settings",
    }
}); };
